import { mande } from "mande";
const BASE_URL = import.meta.env.VITE_SERVICES_BASEURL;

const inventory = mande(BASE_URL + "/api/inventory");

export function loadInventory() {
  return inventory.get();
}
